import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '@/locales/en.json';
import arTranslation from '@/locales/ar.json';
import { applyDocumentDirection, getLanguageCode } from '@/lib/direction';

const resources = {
  en: {
    translation: enTranslation
  },
  ar: {
    translation: arTranslation
  },
};

const storedLanguage = typeof window !== 'undefined' ? localStorage.getItem('language') : null;
const initialLanguage = storedLanguage && resources[getLanguageCode(storedLanguage) as keyof typeof resources]
  ? getLanguageCode(storedLanguage)
  : 'ar';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (language) => {
  const normalizedLanguage = getLanguageCode(language);
  localStorage.setItem('language', normalizedLanguage);
  applyDocumentDirection(normalizedLanguage);
});

if (typeof document !== 'undefined') {
  applyDocumentDirection(i18n.resolvedLanguage || i18n.language);
}

export default i18n;
